import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Form } from "antd";
import { useIntl } from "react-intl";

import RangePickerItem, {
  getDateFromRangePicker,
} from "../../app/generic/rangePickerItem";
import InputItem from "../../app/generic/inputItem";
import TableFilter from "../../app/generic/tableFilter";
import FilterSubmit from "../../app/generic/tableFilter/filterSubmit";

const formName = "template-list";

function TemplateListFilter({
  form,
  showFilter,
  loadTemplates,
  onSetShowFilter,
}) {
  const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 15 },
    colon: false,
  };
  const intl = useIntl();
  const { getFieldDecorator } = form;

  const [filterState] = useState(
    useSelector((state) => state.filter[formName])
  );
  useEffect(
    () => filterState && onSetShowFilter(true),
    [filterState, onSetShowFilter]
  );

  useEffect(() => {
    loadTemplates && loadTemplates(filterState && filterState.data);
  }, [loadTemplates, filterState]);

  const handleFiltering = useCallback(
    (e, onSetFilterState) => {
      e.preventDefault();
      form.validateFields((err, values) => {
        if (!err) {
          const params = {
            ...values,
            createFrom: getDateFromRangePicker(values.createDate, 0),
            createTo: getDateFromRangePicker(values.createDate, 1),
            createDate: undefined,
          };
          loadTemplates(params);
          onSetFilterState(params);
        }
      });
    },
    [form, loadTemplates]
  );

  return (
    <TableFilter showFilter={showFilter}>
      <Form {...formItemLayout}>
        <Row>
          <Col span={12}>
            <InputItem
              label={intl.formatMessage({
                id: "consignment.template.templateName",
                defaultMessage: "Název šablony",
              })}
              fieldName="templateName"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <RangePickerItem
              showRanges
              label={intl.formatMessage({
                id: "consignment.template.insertionDateTime",
                defaultMessage: "Datum vytvoření",
              })}
              fieldName="createDate"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
          </Col>
          <Col span={12}>
            <InputItem
              label={intl.formatMessage({
                id: "consignment.template.creator",
                defaultMessage: "Tvůrce šablony",
              })}
              fieldName="creator"
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
            />
            <FilterSubmit
              form={form}
              formName={formName}
              filterState={filterState}
              onFilterClick={handleFiltering}
            />
          </Col>
        </Row>
      </Form>
    </TableFilter>
  );
}

export default Form.create()(TemplateListFilter);
